import React from 'react';
import stylesPlain from '../../components/plain/plain.module.css';

import PlainPage from '../../components/plain/PlainPage';
import FieldString from '../../components/plain/FieldString';
import TabbedPane from '../../components/plain/TabbedPane';
import Label from '../../components/input/Label';

import {FORM_ROLE_PLAIN} from '../../util/consts/forms';

class RolePlainPage extends PlainPage {

	constructor(props) {
		super(props);
		this.formPath = FORM_ROLE_PLAIN;
		this.formTitle = 'Роль';
		this.buildInstanceCard = this.buildRoleCard;
	}
	componentDidMount = async () => {
		this.init('Role')
		document.title = 'BOM. ' + this.formTitle;
	}
	createInstanceFromBean(bean) {
		let instance = super.createInstanceFromBean(bean);
		let listClass = instance.rootField.value.listObjectAccess;
		for( let classAgent of this.realm.listClass) {
			let classId = classAgent.id;
			let containsClassId = false;
			for(let cls of listClass.value) {
				if( cls.value.classId.value == classId ) {
					containsClassId = true;
					break;
				}
			}
			if( ! containsClassId ) {
				let item = instance.addListItem(listClass);
				item.value.classId.value = classId;
				item.value.canCreate.value = 0;
				item.value.canRead.value = 0;
				item.value.canReadOwn.value = 0;
				item.value.canReadGroup.value = 0;
				item.value.canUpdate.value = 0;
				item.value.canUpdateOwn.value = 0;
				item.value.canUpdateGroup.value = 0;
				item.value.canDelete.value = 0;
				item.value.canDeleteOwn.value = 0;
				item.value.canDeleteGroup.value = 0;
			}
		}

		let listForm = instance.rootField.value.listFormAccess;
		for( let formAgent of this.realm.listForm) {
			let formId = formAgent.id;
			let containsFormId = false;
			for(let f of listForm.value) {
				if( f.value.formId.value == formId ) {
					containsFormId = true;
					break;
				}
			}
			if( ! containsFormId ) {
				let item = instance.addListItem(listForm);
				item.value.formId.value = formId;
				item.value.canView.value = 0;
				item.value.canViewGroup.value = 0;
				item.value.canViewOwn.value = 0;
			}
		}

		let listAction = instance.rootField.value.listActionAccess;
		for( let actionAgent of this.realm.listAction) {
			let actionId = actionAgent.id;
			let containsActionId = false;
			for(let a of listAction.value) {
				if( a.value.actionId.value == actionId ) {
					containsActionId = true;
					break;
				}
			}
			if( ! containsActionId ) {
				let item = instance.addListItem(listAction);
				item.value.actionId.value = actionId;
				item.value.canPerform.value = 0;
			}
		}

		let listAccess = instance.rootField.value.listAbstractAccess;
		for( let accessAgent of this.realm.listAccess) {
			let accessId = accessAgent.id;
			let containsAccessId = false;
			for(let a of listAccess.value) {
				if( a.value.accessId.value == accessId ) {
					containsAccessId = true;
					break;
				}
			}
			if( ! containsAccessId ) {
				let item = instance.addListItem(listAccess);
				item.value.accessId.value = accessId;
				item.value.hasAccess.value = 0;
			}
		}
		
		return instance;
	}
	
	buildRoleCard = (roleInstance) => {
		let card = '';
		if( roleInstance.rootField.value.roleId.value )
			card += roleInstance.rootField.value.roleId.value + ': ';
		if( roleInstance.rootField.value.title.value )
			card += roleInstance.rootField.value.title.value;
		return card;
	}
	
	setObjectAccess = (e, classId, action) => {
		let listClass = this.instance.rootField.value.listObjectAccess;
		let classAccess = null;
		for(let cls of listClass.value) {
			if( cls.value.classId.value == classId) {
				classAccess = cls;
				break;
			}
		}
		classAccess.value[action].value = e.target.checked ? 1 : 0;
		this.setState({instance: this.instance});
	}
	setFormAccess = (e, formId) => {
		let formAccess = this.getFormAccess( formId );
		formAccess.value.canView.value = e.target.checked ? 1 : 0;
		this.setState({instance: this.instance});
	}
	setFormAccessGroup = (e, formId) => {
		let formAccess = this.getFormAccess( formId );
		formAccess.value.canViewGroup.value = e.target.checked ? 1 : 0;
		this.setState({instance: this.instance});
	}
	setFormAccessOwn = (e, formId) => {
		let formAccess = this.getFormAccess( formId );
		formAccess.value.canViewOwn.value = e.target.checked ? 1 : 0;
		this.setState({instance: this.instance});
	}
	getFormAccess = (formId) => {
		let listForm = this.instance.rootField.value.listFormAccess;
		for(let form of listForm.value) {
			if( form.value.formId.value == formId) {
				return form;
			}
		}
		return null;
	}
	setActionAccess = (e, actionId) => {
		let listAction = this.instance.rootField.value.listActionAccess;
		let actionAccess = null;
		for(let action of listAction.value) {
			if( action.value.actionId.value == actionId) {
				actionAccess = action;
				break;
			}
		}
		actionAccess.value.canPerform.value = e.target.checked ? 1 : 0;
		this.setState({instance: this.instance});
	}
	setAbstractAccess = (e, accessId) => {
		let listAccess = this.instance.rootField.value.listAbstractAccess;
		let access = null;
		for(let a of listAccess.value) {
			if( a.value.accessId.value == accessId) {
				access = a;
				break;
			}
		}
		access.value.hasAccess.value = e.target.checked ? 1 : 0;
		this.setState({instance: this.instance});
	}
	
	renderBody() {
		let tabs = [
			{
				rowId: 'tabRow',
				tabs: [
					{ tabId: 'object', tabTitle: 'Обєкти', }, 
					{ tabId: 'formTable', tabTitle: 'Табличні форми', },
					{ tabId: 'formPlain', tabTitle: 'Форми редагування', },
					{ tabId: 'action', tabTitle: 'Дії', },
					{ tabId: 'access', tabTitle: 'Доступ', },
				]
			},
		];
		let instance = this.state.instance;
		
		return (
			<div className={stylesPlain.divPlainMain}>
				{this.renderHeader()}
				
				{/* Body */}
				<div className={stylesPlain.divPlainBody} >
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
						<FieldString instance={instance} path={'/roleId'} plain={this}
							readOnly={this.instanceReadOnly || this.instance.id != null} 
							styles={{ input: {flexGrow: '1', marginRight: '20px'} }}
						/>
						<FieldString instance={instance} path={'/title'} plain={this}
							readOnly={this.instanceReadOnly} 
							styles={{ input: {flexGrow: '5'} }}
						/>
					</div>
					<div style={{display: 'flex', alignItems: 'center', marginBottom: '20px'}}>
						<FieldString instance={instance} path={'/description'} plain={this}
							readOnly={this.instanceReadOnly} 
							styles={{ input: {flexGrow: '1', } }}
						/>
					</div>
					<TabbedPane tabs={tabs} createTab={this.createTab} 
						styles={{ divMain: {border: '1px solid gray', marginTop: '10px'} }} 
					/>
				</div>
			</div>
		);
	}
	createTab = (tabId) => {
		if( tabId == 'object' )
			return <TabObject plain={this} instance={this.state.instance} readOnly={this.instanceReadOnly} />;
		if( tabId == 'formTable' )
			return <TabFormTable plain={this} instance={this.state.instance} readOnly={this.instanceReadOnly} />;
		if( tabId == 'formPlain' )
			return <TabFormPlain plain={this} instance={this.state.instance} readOnly={this.instanceReadOnly} />;
		if( tabId == 'action' )
			return <TabAction plain={this} instance={this.state.instance} readOnly={this.instanceReadOnly} />;
		if( tabId == 'access' )
			return <TabAccess plain={this} instance={this.state.instance} readOnly={this.instanceReadOnly} />;
		return null;
	}
		
}

function TabObject(props) {
	
	if(props.plain.realm == null)
		return null;
	
	let rowsHtml = props.plain.realm.listClass.map( (classAgent, index) => {
		let listClass = props.instance.rootField.value.listObjectAccess;
		let classAccess = null;
		for(let cls of listClass.value) {
			if( cls.value.classId.value == classAgent.id) {
				classAccess = cls;
				break;
			}
		}
		return (
			<tr key={index}>
				<td>{classAgent.id}</td>
				<td>
					<Label title={classAgent.title} tooltip={classAgent.description}
						styles={{divMain: {color: 'black', fontStyle: 'normal'}}} 
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canCreate.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canCreate')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canReadOwn.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canReadOwn')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canReadGroup.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canReadGroup')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canRead.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canRead')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canUpdateOwn.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canUpdateOwn')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canUpdateGroup.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canUpdateGroup')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canUpdate.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canUpdate')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canDeleteOwn.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canDeleteOwn')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canDeleteGroup.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canDeleteGroup')}}
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={classAccess.value.canDelete.value == 1} 
						onChange={(e) => {props.plain.setObjectAccess(e, classAgent.id, 'canDelete')}}
					/>
				</td>
			</tr>
		);
	} );
	
	return (
		<div style={{padding: '20px 20px 20px 20px' }}>
		<table border='``'>
			<thead>
				<tr style={{fontWeight: 'bold'}}>
					<td align='center'>Клас</td>
					<td align='center'>Назва</td>
					<td align='center'>Створювати</td>
					<td align='center'>Читати власні</td>
					<td align='center'>Читати групові</td>
					<td align='center'>Читати всі</td>
					<td align='center'>Редагувати власні</td>
					<td align='center'>Редагувати групові</td>
					<td align='center'>Редагувати всі</td>
					<td align='center'>Вилучати власні</td>
					<td align='center'>Вилучати групові</td>
					<td align='center'>Вилучати всі</td>
				</tr>
			</thead>
			<tbody>
				{rowsHtml}
			</tbody>
		</table>
		</div>
	);
}

function TabFormTable(props) {
	
	if(props.plain.realm == null)
		return null;
	
	return (
		<div style={{padding: '20px 20px 20px 20px' , display: 'flex'}}>
			<FormTable formType='table' plain={props.plain} instance={props.instance} />
		</div>
	);
}
function TabFormPlain(props) {
	
	if(props.plain.realm == null)
		return null;
	
	return (
		<div style={{padding: '20px 20px 20px 20px' , display: 'flex'}}>
			<div style={{marginRight: '10px'}}>
				<FormTable formType='ft' plain={props.plain} instance={props.instance} />
			</div>
			<FormTable formType='plain' plain={props.plain} instance={props.instance} />
		</div>
	);
}
function FormTable(props) {
	
	let rowsHtml = props.plain.realm.listForm.map( (formAgent, index) => {
		if( formAgent.type != props.formType )
			return null;
		let formAccess = props.plain.getFormAccess( formAgent.id );
		let tableFormAccessHtml = null;
		if( props.formType == 'table' ) {
			tableFormAccessHtml = (
				<React.Fragment>
					<td align='center'>
						<input type='checkbox' checked={formAccess.value.canViewOwn.value == 1} 
							onChange={(e) => {props.plain.setFormAccessOwn(e, formAgent.id)}}
						/>
					</td>
					<td align='center'>
						<input type='checkbox' checked={formAccess.value.canViewGroup.value == 1} 
							onChange={(e) => {props.plain.setFormAccessGroup(e, formAgent.id)}}
						/>
					</td>
				</React.Fragment>
			)
		}
		return (
			<tr key={index}>
				<td>{formAgent.id}</td>
				<td>
					<Label title={formAgent.title} tooltip={formAgent.description}
						styles={{divMain: {color: 'black', fontStyle: 'normal'}}} 
					/>
				</td>
				{tableFormAccessHtml}
				<td align='center'>
					<input type='checkbox' checked={formAccess.value.canView.value == 1} 
						onChange={(e) => {props.plain.setFormAccess(e, formAgent.id)}}
					/>
				</td>
			</tr>
		);
	} );
	
	let tableFormAccessHeaderHtml = null;
	let colShowAllTitle;
	if( props.formType == 'table' ) {
		colShowAllTitle = 'Переглядати всі';
		tableFormAccessHeaderHtml = (
			<React.Fragment>
				<td align='center'>Переглядати власні</td>
				<td align='center'>Переглядати групові</td>
			</React.Fragment>
		)
	} else {
		colShowAllTitle = 'Доступна';
	}
	
	return (
		<table border='``'>
			<thead>
				<tr style={{fontWeight: 'bold'}}> 
					<td align='center'>Ідентифікатор</td>
					<td align='center'>Назва</td>
					{tableFormAccessHeaderHtml}
					<td align='center'>{colShowAllTitle}</td>
				</tr>
			</thead>
			<tbody>
				{rowsHtml}
			</tbody>
		</table>
	);
}

function TabAction(props) {
	
	if(props.plain.realm == null)
		return null;
	
	let rowsHtml = props.plain.realm.listAction.map( (actionAgent, index) => {
		let listAction = props.instance.rootField.value.listActionAccess;
		let actionAccess = null;
		for(let action of listAction.value) {
			if( action.value.actionId.value == actionAgent.id) {
				actionAccess = action;
				break;
			}
		}
		return (
			<tr key={index}>
				<td>{actionAgent.id}</td>
				<td>
					<Label title={actionAgent.title} tooltip={actionAgent.description}
						styles={{divMain: {color: 'black', fontStyle: 'normal'}}} 
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={actionAccess.value.canPerform.value == 1} 
						onChange={(e) => {props.plain.setActionAccess(e, actionAgent.id)}}
					/>
				</td>
			</tr>
		);
	} );
	
	return (
		<div style={{padding: '20px 20px 20px 20px' }}>
		<table border='``'>
			<thead>
				<tr style={{fontWeight: 'bold'}}>
					<td align='center'>Ідентифікатор</td>
					<td align='center'>Назва</td>
					<td align='center'>Виконувати</td>
				</tr>
			</thead>
			<tbody>
				{rowsHtml}
			</tbody>
		</table>
		</div>
	);
}

function TabAccess(props) {
	
	if(props.plain.realm == null)
		return null;
	
	let rowsHtml = props.plain.realm.listAccess.map( (accessAgent, index) => {
		let listAccess = props.instance.rootField.value.listAbstractAccess;
		let access = null;
		for(let a of listAccess.value) {
			if( a.value.accessId.value == accessAgent.id) {
				access = a;
				break;
			}
		}
		return (
			<tr key={index}>
				<td>{accessAgent.id}</td>
				<td>
					<Label title={accessAgent.title} tooltip={accessAgent.description}
						styles={{divMain: {color: 'black', fontStyle: 'normal'}}} 
					/>
				</td>
				<td align='center'>
					<input type='checkbox' checked={access.value.hasAccess.value == 1} 
						onChange={(e) => {props.plain.setAbstractAccess(e, accessAgent.id)}}
					/>
				</td>
			</tr>
		);
	} );
	
	return (
		<div style={{padding: '20px 20px 20px 20px' }}>
		<table border='``'>
			<thead>
				<tr style={{fontWeight: 'bold'}}>
					<td align='center'>Ідентифікатор</td>
					<td align='center'>Назва</td>
					<td align='center'>Мати доступ</td>
				</tr>
			</thead>
			<tbody>
				{rowsHtml}
			</tbody>
		</table>
		</div>
	);
}

export default RolePlainPage;